import type { SuggestionType } from '@apps/main/new-desktop/modules/suggestionTypeSelector';

import type { TagData } from '@libs/ui';
import type { IngredientId } from '@libs/trip-planner-interfaces';

import type { ItinerarySegmentType } from './itinerarySegmentType';
import type {
  CarrierLogo,
  PortDetails,
  ProductTagWithIcon,
  UnavailabilityReason,
} from './shared';
import type { ItineraryFerryLoaderSegment } from './loaderSegments';

export interface FerryCardDetails {
  date: string;
  logo: CarrierLogo;
  time: string;
  warningTags: ProductTagWithIcon[];
  changeButtonText: string;
  mainDetails?: string;
  shipName?: string;
  carrier?: string;
}

export interface FerryTicketPrices {
  type: string;
  price?: number;
  basePrice?: number;
}

export interface FerryUpsell {
  ingredientId: IngredientId;
  ticket: FerryTicketPrices;
  vehicles: string[];
  cabin: boolean;
  transportationName?: string;
  token: string;
  allowVehicles: boolean;
}

export interface FerryProductCardData {
  fromPort: PortDetails;
  toPort: PortDetails;
  details: FerryCardDetails;
  upsell: FerryUpsell;
}

export interface AvailableItineraryFerrySegment {
  isAvailable: true;
  segmentType: ItinerarySegmentType.Ferry;
  productCardData: FerryProductCardData;
  ingredientId: IngredientId;
  suggestionType: SuggestionType | undefined;
  filtersPills: TagData[];
}

export interface UnavailableItineraryFerrySegment {
  isAvailable: false;
  segmentType: ItinerarySegmentType.Ferry;
  productCardData: null;
  ingredientId: IngredientId;
  reasons: UnavailabilityReason[];
}

export type ItineraryFerrySegment =
  | AvailableItineraryFerrySegment
  | UnavailableItineraryFerrySegment;

export function isItineraryFerrySegment(
  segment: ItineraryFerryLoaderSegment | ItineraryFerrySegment
): segment is ItineraryFerrySegment {
  return 'isAvailable' in segment;
}

export function isAvailableItineraryFerrySegment(
  segment: ItineraryFerrySegment
): segment is AvailableItineraryFerrySegment {
  return segment.isAvailable;
}
